import { createReactApp } from '@slicesjs/react-app';

import packageJson from '../package.json';
import App from './app';

export const { mount } = createReactApp(App, {
  packageName: packageJson.name,
  onError: (error: Error) => {
    console.error('Error creating registration slice', error);
  },
});
